<ng-content></ng-content>
<ng-container *ngFor="let column of columns; trackBy: trackBy">
  <ng-container
    *ngIf="
      enableRowEditing &&
      column.editable &&
      checkRowEditingCondition(rowEditingEnableConditionColumn, rowEditingEnableConditionValue, data[rowEditingEnableConditionColumn])
    "
  >
    <td
      class="cell-editor"
      [style.width.px]="column.width"
      [style.maxWidth.px]="column.width"
      [style.flexBasis.px]="column.width"
      [style.justifyContent]="column.align | columnAlignment"
      [ngClass]="data?.meta?.attributes?.column?.[column.field]?.class"
      [ngStyle]="data?.meta?.attributes?.column?.[column.field]?.style"
      [attr.data-field]="column.field"
    >
      <ng-container *ngIf="rowEditingActive$ | async">
        <ng-container *ngIf="column.type === 'date'">
          <div class="z-date grid-cell-editor">
            <p-calendar
              styleClass="z-date-input"
              panelStyleClass="z-date-panel"
              [(ngModel)]="data[column.field]"
              [showButtonBar]="true"
              [showOnFocus]="true"
              [showTime]="false"
              [showSeconds]="false"
              [showIcon]="false"
              appendTo="body"
              [dateFormat]="environmentService.primeNgDateLongFormat"
              [hourFormat]="environmentService.primeNgTime12Format"
            ></p-calendar>
          </div>
        </ng-container>

        <ng-container *ngIf="column.type === 'datetime'">
          <div class="z-date grid-cell-editor">
            <p-calendar
              styleClass="z-date-input"
              panelStyleClass="z-date-panel"
              [(ngModel)]="data[column.field]"
              [showButtonBar]="true"
              [showOnFocus]="true"
              [showTime]="true"
              [showSeconds]="false"
              [showIcon]="false"
              appendTo="body"
              [dateFormat]="environmentService.primeNgDateLongFormat"
              [hourFormat]="environmentService.primeNgTime12Format"
            ></p-calendar>
          </div>
        </ng-container>

        <ng-container *ngIf="!column.type || (column.type !== 'date' && column.type !== 'datetime')">
          <input
            *ngIf="!column.editOptions.type || column.editOptions.type === 'string'"
            zTextInput
            class="grid-cell-editor"
            [(ngModel)]="data[column.field]"
            [uppercase]="column.editOptions.uppercase ?? true"
          />

          <textarea
            *ngIf="column.editOptions.type === 'textarea'"
            pInputTextarea
            class="grid-cell-editor"
            [(ngModel)]="data[column.field]"
          ></textarea>

          <div class="z-combo-box grid-cell-editor" *ngIf="column.editOptions.type === 'dropdown'">
            <div class="p-inputgroup">
              <p-dropdown
                appendTo="body"
                [autoDisplayFirst]="false"
                panelStyleClass="z-combo-box"
                [(ngModel)]="data[column.field]"
                [options]="column.editOptions.list"
                optionValue="column2"
                optionLabel="column2"
              ></p-dropdown>
            </div>
          </div>

          <div class="grid-cell-editor" *ngIf="column.editOptions.type === 'carrier'">
            <z-carrier-lookup [fieldName]="column.field"></z-carrier-lookup>
          </div>
        </ng-container>
      </ng-container>

      <ng-container *ngIf="(rowEditingActive$ | async) === false">
        <ng-container *ngIf="column.type === 'icon' && column.data">
          <ng-container
            *ngIf="column.data.showIconClass && (column.data.alwaysShowIcon || column.data.showIconValueEquals === data[column.field])"
          >
            <i [ngClass]="column.data.showIconClass"></i>
          </ng-container>

          <ng-container *ngIf="column.data.hideIconClass && column.data.hideIconValueEquals === data[column.field]">
            <i [ngClass]="column.data.hideIconClass"></i>
          </ng-container>
        </ng-container>

        <ng-container *ngIf="column.type === 'date'">
          {{ data[column.field] | date : environmentService.dateLongFormat : 'GMT' }}
        </ng-container>

        <ng-container *ngIf="column.type === 'datetime'">
          {{ data[column.field] | date : environmentService.dateTimeLongFormat : 'GMT' }}
        </ng-container>

        <ng-container *ngIf="column.type === 'number'">
          <ng-container *ngIf="column.formatter === 'money'">
            {{ data[column.field] | currency }}
          </ng-container>

          <ng-container *ngIf="column.formatter === 'decimal'">
            {{ data[column.field] | number : '1.0-4' }}
          </ng-container>

          <ng-container *ngIf="column.formatter === 'number'">
            {{ data[column.field] | number : '1.0-2' }}
          </ng-container>

          <ng-container *ngIf="!column.formatter">
            {{ data[column.field] | number : '1.0-0' }}
          </ng-container>
        </ng-container>

        <ng-container *ngIf="column.type === 'string'">
          <ng-container *ngIf="column.formatter === 'yn'">
            {{ data[column.field] | yn | transloco }}
          </ng-container>

          <ng-container *ngIf="!column.formatter">
            {{ data[column.field] }}
          </ng-container>
        </ng-container>
      </ng-container>
    </td>
  </ng-container>

  <ng-container
    *ngIf="
      !enableRowEditing ||
      !column.editable ||
      !checkRowEditingCondition(rowEditingEnableConditionColumn, rowEditingEnableConditionValue, data[rowEditingEnableConditionColumn])
    "
  >
    <td
      [style.width.px]="column.width"
      [style.flexBasis.px]="column.width"
      [style.maxWidth.px]="column.width"
      [style.justifyContent]="column.align | columnAlignment"
      [ngClass]="data?.meta?.attributes?.column?.[column.field]?.class"
      [ngStyle]="data?.meta?.attributes?.column?.[column.field]?.style"
      [attr.data-field]="column.field"
    >
      <ng-container *ngIf="column.type === 'icon' && column.data">
        <ng-container
          *ngIf="column.data.showIconClass && (column.data.alwaysShowIcon || column.data.showIconValueEquals === data[column.field])"
        >
          <i [ngClass]="column.data.showIconClass"></i>
        </ng-container>

        <ng-container *ngIf="column.data.hideIconClass && column.data.hideIconValueEquals === data[column.field]">
          <i [ngClass]="column.data.hideIconClass"></i>
        </ng-container>
      </ng-container>

      <ng-container *ngIf="column.type === 'date'">
        {{ data[column.field] | date : environmentService.dateLongFormat : 'GMT' }}
      </ng-container>

      <ng-container *ngIf="column.type === 'datetime'">
        {{ data[column.field] | date : environmentService.dateTimeLongFormat : 'GMT' }}
      </ng-container>

      <ng-container *ngIf="column.type === 'number'">
        <ng-container *ngIf="column.formatter === 'money'">
          {{ data[column.field] | currency }}
        </ng-container>

        <ng-container *ngIf="column.formatter === 'decimal'">
          {{ data[column.field] | number : '1.0-4' }}
        </ng-container>

        <ng-container *ngIf="column.formatter === 'number'">
          {{ data[column.field] | number : '1.0-2' }}
        </ng-container>

        <ng-container *ngIf="!column.formatter">
          {{ data[column.field] | number : '1.0-0' }}
        </ng-container>
      </ng-container>

      <ng-container *ngIf="column.type === 'string'">
        <ng-container *ngIf="column.formatter === 'yn'">
          {{ data[column.field] | yn | transloco }}
        </ng-container>

        <ng-container *ngIf="!column.formatter">
          {{ data[column.field] }}
        </ng-container>
      </ng-container>
    </td>
  </ng-container>
</ng-container>
